import React from "react";
import { Form } from 'antd';
import { displayIcon } from "variables/icons";

function FormItem(props) {
  const { label, labelExtra, icon: Icon, extra = "", children, value, displayExtra, colon=false, iconName, formExtra,
 ...rest } = props;

  return (
    <Form.Item
      colon={colon}
      className={`font-medium mb-2 ${extra}`}
      extra={formExtra}
      label={
        label ? (
          <div className="flex items-center gap-2">
            {iconName ? displayIcon(iconName, 'w-4 h-4 text-purple-600 dark:text-purple-400')
                      : Icon && <Icon className="w-4 h-4 text-purple-600 dark:text-purple-400" />}
            <span className="text-sm label-title">{label}</span>
            {labelExtra}
          </div>
        ) : (
          false
        )
      }
      {...rest}
    >
      {children ? (
        children
      ) : (
        <div className={`text-base label-value ${displayExtra}`}>{value}</div>
      )}
    </Form.Item>
  );
}

export default FormItem;

